module.exports = __webpack_public_path__ + "img/play-button.9f5ff09b.png";